import styled from 'styled-components';
import { lighten } from 'polished';
import { blue2 } from '@styles/styled/variables';
import Table from '@components/common/Table';

export const Wrapper = styled.div<{ expand: boolean }>`
  margin: 20px 115px 20px 220px;
  display: ${props => (props.expand ? 'block' : 'none')};
  box-sizing: border-box;
`;

export const StyledBaseTable = styled(Table)<{
  activeIndex: number;
}>`

  .BaseTable__column-resizer {
    transition: 0.2 all ease-in;
    background: ${lighten(0.2, '#4A4A4A')};
    &:hover {
      background: ${lighten(0.15, '#4A4A4A')};
    }
  }
  .BaseTable__empty-layer {
    height: 100px;
  }
  .BaseTable__row {
    transition: 0.2s all ease-in;
    cursor: pointer;
    &:hover,
    &.BaseTable__row--hovered {
      background-color: ${lighten(0.02, blue2)};
    }
    &:active {
      background-color: ${blue2};
    }
    ${props => {
    if (props.activeIndex === -1) {
      return '';
    }
    return `
        &:nth-child(${props.activeIndex + 1}) {
          background-color: ${blue2};
        }
      `;
  }}
  }
`;
